module.exports = __webpack_public_path__ + "static/media/fourth-banner-icon.e2e73886.png";